/*!
 * EGT announcement-bar items (N2) — the single source of truth for the
 * site-wide announcement strip that renders ABOVE the nav on every EGT surface.
 *
 * Plain data module (no element, no dependency). app/elements/egt.announce.js
 * reads this at render time and emits one restrained, single-line frosted bar;
 * app/public/src/egt.announce.js rotates through the active items client-side.
 *
 * Each item:
 *   text    — one short line. Keep it restrained; this sits above the brand and
 *             must NOT read as a promo bar. No published DATES in the copy.
 *   href    — where the line links.
 *   icon    — a Bootstrap-Icons glyph class (e.g. "bi-book"); rendered gold-ish
 *             in the item's own `colour`.
 *   colour  — the per-item accent (icon + tick), set inline as
 *             --egt-announce-accent. Scarce gold #C48E2F for the primary line;
 *             neutral #ADB5BD for the quieter ones.
 *   start   — OPTIONAL ISO date/time. Before it, the item is not shown.
 *   end     — OPTIONAL ISO date/time. After it, the item is not shown.
 *             Omit both = always active. When NO item is active the bar is
 *             removed from the DOM entirely (server renders nothing; the client
 *             also re-checks the window on load and drops the section).
 *
 * PLACEHOLDER COPY (founder will tweak): three restrained one-liners, Exploit
 * first. True today — the platform is in public beta, agency clients are already
 * on it (agents.md §4), and Exploit: Act 1 has released. No dates, no "draft".
 */

var ITEMS = [
  /* Push Past Pain — 48-HOUR LAUNCH FEATURE (Isaiah Carter's real story). Sits
   * first + gold so it leads the bar during the window. It carries an `end`
   * ONLY (no start), so the moment it expires the announce client drops it from
   * the DOM on load (app/public/src/egt.announce.js) and the bar reverts to its
   * normal rotation with NO reboot required. The Exploit line below is left
   * untouched (still active), so nothing is lost and the post-expiry state is
   * exactly the prior state. Window set 2026-08-14 ~18:00Z → +48h. */
  {
    text: "Carter's Real Story — Push Past Pain — Listen Now",
    href: "/entertainment/push-past-pain",
    icon: "bi-music-note-beamed",
    colour: "#C48E2F",
    end: "2026-08-16T18:00:00Z"
  },
  {
    /* 2026-08-21 founder directive: the Exploit line no longer sells the book.
     * It sends readers to the free opening chapters and the launch list. */
    text: "Read the first chapters of Exploit free — Book One of The Universe.",
    href: "/exploit/free",
    icon: "bi-book",
    colour: "#C48E2F"
  },
  {
    text: "The Universe Platform is in public beta — reserve your lane.",
    href: "/reserve",
    icon: "bi-stars",
    colour: "#ADB5BD"
  },
  {
    text: "EGT Forge — strategy, film, design, and the launch.",
    href: "/forge",
    icon: "bi-hammer",
    colour: "#ADB5BD"
  },
  {
    text: "Introducing a fully equipped AI Film Studio.",
    href: "/studio",
    icon: "bi-film",
    colour: "#ADB5BD"
  },
  {
    text: "Your Story. Your film. Finally gets made.",
    href: "/studio",
    icon: "bi-camera-reels",
    colour: "#ADB5BD"
  }
];
exports.ITEMS = ITEMS;

/* Parse an optional start/end value to a millisecond timestamp, or null if it
 * is absent/unparseable (treated as "no bound on this side"). */
function toTime(v) {
  if (v === undefined || v === null || v === "") { return null; }
  var t = Date.parse(v);
  return isNaN(t) ? null : t;
}
exports.toTime = toTime;

/* True when `item` is inside its [start, end] window at `now` (ms). An omitted
 * bound is open on that side. */
function isActive(item, now) {
  if (!item) { return false; }
  var s = toTime(item.start);
  var e = toTime(item.end);
  if (s !== null && now < s) { return false; }
  if (e !== null && now > e) { return false; }
  return true;
}
exports.isActive = isActive;

/* The items active right now (or at the supplied `now` ms). Used by the element
 * to decide whether to render the bar at all. */
/* MASTER SWITCH — founder 2026-10-06: the announcement bar is OFF for now.
 * Flip to true to bring it back; the items above stay as they are. While off,
 * activeItems() returns nothing, so the bar is not rendered on any page. */
var ENABLED = false;
exports.ENABLED = ENABLED;

exports.activeItems = function activeItems(now) {
  if (!ENABLED) { return []; }
  var at = (typeof now === "number") ? now : Date.now();
  return ITEMS.filter(function (it) { return isActive(it, at); });
};
